module.exports = __webpack_public_path__ + "static/media/SDFSA_5-317w.0ee94ad6.webp";